<div class='container'>
    <!-- <img class="imgCenterPNF" src="assets/images/Error-404.gif" /> -->
    <mat-spinner class="spinner"></mat-spinner>
</div>

 
